export default {
      id: "info-circle-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#info-circle",
      toString: function () {
        return this.url;
      }
    }